import { render, staticRenderFns } from "./detailCase.vue?vue&type=template&id=e2c80c96"
import script from "./detailCase.vue?vue&type=script&lang=js"
export * from "./detailCase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports